import React, { useEffect, useState } from 'react';
import SimpleLoader from 'components/loader/SimpleLoader';
import HomeCard from '../HomeCard';
import { HomePageProps } from 'types/Filters';
import PaginationComponent from 'components/pager/Pagination';
import LeftFilters from './LeftSideFilters';
import SortingDropDown from './SortingDropDowns';
import EmptySearchResult from 'components/search/EmptySearchResult';
import { DatasetListItem } from 'types/Dataset';

export default function FilterView({
    items,
    error,
    loading,
    filter,
    setFilter,
}: HomePageProps) {
    const [completeDatasets, setCompleteDatasets] = useState<DatasetListItem[]>(
        [],
    );
    const [hideIncomplete, setHideIncomplete] = useState<boolean>(
        completeDatasets.length > 0,
    );

    useEffect(() => {
        const completes = items.nodes.filter(
            (item: DatasetListItem) =>
                !(
                    item.statistics.tables === 0 &&
                    item.statistics.locations === 0
                ),
        );
        setCompleteDatasets(completes);
        setHideIncomplete(completes.length > 0);
    }, [items.nodes]);
    return (
        <div>
            {!error &&
                (items.nodes.length === 0 ? (
                    <EmptySearchResult />
                ) : (
                    <div className="lg:flex block">
                        <LeftFilters
                            filter={filter}
                            setFilter={setFilter}
                            hideIncomplete={hideIncomplete}
                            setHideIncomplete={setHideIncomplete}
                        />
                        <div className="lg:ml-32 ml-0 w-full">
                            <div className="flex justify-end items-end mb-16">
                                <SortingDropDown setFilter={setFilter} />
                            </div>
                            {loading ? (
                                <SimpleLoader />
                            ) : hideIncomplete ? (
                                <div className="filter-grid">
                                    {completeDatasets.map((item, index) => (
                                        <div
                                            key={index}
                                            className="home-page-grid-card-div"
                                        >
                                            <HomeCard {...item} />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div>
                                    <div className="filter-grid">
                                        {items.nodes.map((item, index) => (
                                            <div
                                                key={index}
                                                className="home-page-grid-card-div"
                                            >
                                                <HomeCard {...item} />
                                            </div>
                                        ))}
                                    </div>
                                    <PaginationComponent
                                        items={items}
                                        filter={filter}
                                        setFilter={setFilter}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                ))}
        </div>
    );
}
